import {course_createSubject_Api, course_deleteSubject_Api, course_editSubject_Api,} from 'apis'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {useState} from 'react'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from 'views/AppLocals/factory/createNotification'
import {NullAsDefault} from 'views/Shared'

export const useSubject = ({
  onCreated = NullAsDefault,
  onUpdated = NullAsDefault,
  onDeleted = NullAsDefault,
  autoRefresh = true,
}) => {
  const t = useTranslate()

  const [refreshKey, setRefreshKey] = useState()

  const onError = notifyOnError(t)

  const onRefresh = () => {
    if (autoRefresh) {
      setRefreshKey(Date.now())
    }
  }

  const { handleAsyncAction: onCreate } = useAsyncAction({
    apiInfo: course_createSubject_Api,
    onError,
    onSuccess: (...args) => {
      successNotify(NotificationActionTypes.CREATE, t)
      onRefresh()
      onCreated(...args)
    },
  })

  const { handleAsyncAction: onUpdate } = useAsyncAction({
    apiInfo: course_editSubject_Api,
    onError,
    onSuccess: (...args) => {
      successNotify(NotificationActionTypes.UPDATE, t)
      onRefresh()
      onUpdated(...args)
    },
  })

  const { handleAsyncAction: onDelete } = useAsyncAction({
    apiInfo: course_deleteSubject_Api,
    onError,
    onSuccess: (...args) => {
      successNotify(NotificationActionTypes.DELETE, t)
      onRefresh()
      onDeleted(...args)
    },
  })

  return {
    onCreate,
    onUpdate,
    onDelete,
    onRefresh,
    refreshKey,
  }
}
